<template>
    <div class="suggestion">
        <div v-if="suggestion">
            <v-expansion-panels multiple class="suggestion__panels">
                <v-expansion-panel
                    v-for="(detail, index) in suggestion.suggestion_details"
                    :key="index"
                >
                    <v-expansion-panel-title>
                    <v-icon class="mr-5">mdi-account-voice</v-icon>
                    {{ detail.topic }} ({{ detail.time_frame.start }} - {{ detail.time_frame.end }})
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <v-list dense lines="two">
                            <v-list-item
                                v-for="(item, idx) in detail.suggestion_items"
                                :key="idx"
                            >
                                <v-list-item-title class="mb-2">
                                    <strong>Improved: </strong> {{ item.improved_sentence }}
                                </v-list-item-title>
                                <v-list-item-title class="mb-2">
                                    <strong>Original:</strong> {{ item.original_sentence }}
                                </v-list-item-title>
                                <v-list-item-title class="mb-2">
                                    <strong>Reason:</strong> {{ item.reasoning }}
                                </v-list-item-title>
                                <v-divider></v-divider>
                            </v-list-item>
                        </v-list>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <v-btn v-else variant="outlined" @click="executeMakeSuggestion">
            Get Suggestions by Gemini
        </v-btn>
        <!-- Making suggestions dialog -->
        <v-dialog v-model="processing" persistent max-width="300">
            <v-card>
                <v-card-text class="text-center">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                    <div>Processing your transcription...</div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Complete making suggestions dialog -->
        <v-dialog v-model="processingComplete" max-width="300">
            <v-card>
                <v-card-title class="text-h5">Processing Complete</v-card-title>
                <v-card-text>
                    Your file has been processed successfully!
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="processingComplete = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Failed dialog -->
        <v-dialog v-model="processingFailed" max-width="300">
            <v-card>
                <v-card-title class="text-h5">Proccesing Failed.</v-card-title>
                <v-card-text>
                    Sorry, we couldn't process your request. <br>Please try again later.
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="processingFailed = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import { Suggestion } from '@/models/models'
import axios from 'axios';

export default defineComponent({
    name: 'SuggestionItem',
    props: {
        suggestion: {
            type: Object as PropType<Suggestion>,
            required: false,
            default: () => null,
        },
        uid: {
            type: String,
            required: true,
        },
        transcriptionId: {
            type: String,
            required: true,
        },
        selectedDate: {
            type: Date,
            required: true,
        }
    },
    setup(props) {
        const processing = ref(false);
        const processingComplete = ref(false);
        const processingFailed = ref(false);
        const store = useStore();

        const getUniqueWordCount = (wordCount: object): number => {
            return Object.keys(wordCount).length;
        };

        const executeMakeSuggestion = async () => {
            try {
                processing.value = true;

                const response = await axios.post(process.env.VUE_APP_CLOUD_RUN_URL + "suggestion",
                    {
                        "user_uid": props.uid,
                        "transcription_id": props.transcriptionId,
                    }
                )

                await store.dispatch('transcriptions/fetchTranscriptionsByDate', {
                    uid: props.uid,
                    date: props.selectedDate,
                });
                await store.dispatch('suggestions/fetchSuggestionsByDate', { 
                    uid: props.uid, 
                    date: props.selectedDate });

                processing.value = false;
                processingComplete.value = true;
                console.log("Cloud Run response:", response.data);
            } catch (error) {
                processing.value = false;
                processingFailed.value = true;
                console.error("Cloud Run process failed:", error);
            }
        }

        return {
            processing,
            processingComplete,
            processingFailed,
            getUniqueWordCount,
            executeMakeSuggestion,
        }
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';

.suggestion {
    margin: 10px auto;
    &__title {
        margin: 20px;
    }
    &__panels {
        width: 95%;
        margin: auto;
    }
}
</style>
